import { render, staticRenderFns } from "./GlobalCompanyInviteByInvestorDialog.vue?vue&type=template&id=91e2647c"
import script from "./GlobalCompanyInviteByInvestorDialog.vue?vue&type=script&lang=js"
export * from "./GlobalCompanyInviteByInvestorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports